export const SHOW_ALL = 'show_all'
export const SHOW_COMPLETED = 'show_completed'
export const SHOW_ACTIVE = 'show_active'



// WEBPACK FOOTER //
// ./src/constants/TodoFilters.js